import React from 'react';
import PropTypes from 'prop-types';
import ProfileImage from 'shared/components/ProfileImage';
import Icon from 'shared/components/Icon';
import s from './ReferralProviderCard.module.scss';
import { Link } from 'react-router';

const ReferralProviderCard = ({
  senderOrReceiver,
  profileImageSrc,
  providerName,
  providerNpi,
  specialty,
  organizationName,
  locationName,
  locationPhone,
  locationFax,
  mapUrl,
  locationVerifiedData,
  locationFaxFirst,
  locationCallFirst,
  hasStaffUsers,
  fullAddress,
  linkLocations,
  id,
  webpageBase,
}) => (
  <div className={s.container}>
    <div className={s.header_section}>
      <h3 className={s.heading}>
        Referral {senderOrReceiver === 'sender' ? 'From' : 'To'}:
      </h3>
    </div>
    <div className={`${s.body} mt-6`}>
      <div className={s.provider_details_section}>
        <div className={s.profile_image_section}>
          <div className={s.profile_image_wrapper}>
            <ProfileImage src={profileImageSrc} />
          </div>
        </div>
        <div>
          <div className={s.name}>{providerName}</div>
          {providerNpi ? (
            <div className="text-xs italic text-gray-500">
              NPI: {providerNpi}
            </div>
          ) : null}
          <div className={`mt-2 ${s.specialty}`}>{specialty}</div>
          <div className={s.organization_name}>
            {organizationName}
            {locationVerifiedData && (
              <span className={s.boolean_indicator}>
                <Icon name="check-circle" tip="Verified Data" />
              </span>
            )}
            {locationFaxFirst && (
              <span className={s.boolean_indicator}>
                <Icon name="fax" tip="Fax First" />
              </span>
            )}
            {locationCallFirst && (
              <span className={s.boolean_indicator}>
                <Icon name="phone" tip="Call First" />
              </span>
            )}
          </div>
        </div>
      </div>
      <br />
      <div className={s.map_section}>
        {!!mapUrl && <img alt="map" src={mapUrl} />}
      </div>
      <div className={s.address}>{fullAddress}</div>
      <div className={s.location_details_section}>
        <div className={s.location_name}>
          {linkLocations ? (
            <span>
              <Link to={`${webpageBase}/locations/${id}`}>{locationName} </Link>
              <span>
                {' '}
                {hasStaffUsers && (
                  <Icon name="users" tip="Has at least one AristaMD user" />
                )}
              </span>
            </span>
          ) : (
            locationName
          )}
        </div>
        <div className={s.location_phone}>
          <Icon name="phone" /> {locationPhone}
        </div>
        {locationFax && (
          <div className={s.location_fax}>
            <Icon name="fax" />
            {locationFax}
          </div>
        )}
      </div>
    </div>
  </div>
);

ReferralProviderCard.propTypes = {
  senderOrReceiver: PropTypes.oneOf(['sender', 'receiver']),
  profileImageSrc: PropTypes.string,
  providerName: PropTypes.string,
  providerNpi: PropTypes.string,
  specialty: PropTypes.string,
  organizationName: PropTypes.string,
  locationName: PropTypes.string,
  locationPhone: PropTypes.string,
  locationFax: PropTypes.string,
};

export default ReferralProviderCard;
